import { fetchWrapper } from '@/_helpers';
import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';

const AssignActivityPlanModal = ({
    show,
    onHide,
    selectedActivityPlan,
    onChange,
    bucket,
    onAssign,
    isLoading,
    teamId,
}) => {
    const [isBusy, setIsBusy] = useState(false);
    const fetchActivityPlans = async () => {
        try {
            setIsBusy(true);
            const response = await fetchWrapper.get(`activityPackages?team=${teamId}&limit=100`);
            setActivityPlans(
                (response.results || []).map((plan) => ({
                    value: plan._id,
                    label: plan.name,
                    ...plan,
                }))
            );
        } catch (error) {
            console.error('Error fetching activity plans:', error);
        } finally {
            setIsBusy(false);
        }
    };
    const [activityPlans, setActivityPlans] = useState([]);

    useEffect(() => {
        if (show) {
            fetchActivityPlans();
        }
    }, [show]);
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Assign Activity Plan to Bucket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Select an activity plan to assign to <strong>{bucket?.name}</strong>. When staff are moved to this
                    bucket, they will automatically be assigned events from this activity plan.
                </p>

                <Form.Group>
                    <Form.Label>Activity Plan</Form.Label>
                    <Select
                        options={activityPlans}
                        value={selectedActivityPlan}
                        onChange={onChange}
                        placeholder="Select an activity plan"
                        isClearable
                        disabled={isBusy}
                        isLoading={isBusy}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onAssign} disabled={!selectedActivityPlan || isLoading}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : 'Assign Plan'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignActivityPlanModal;
